import React, { useState, useEffect, useRef } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../styles/select-style'
import ApiService from '../../../services/ApiService'
import { TypeOfCertificateType } from './types'
import { ParamType } from '../../../pages/ClientPanel/Certificates/CreateParam'

interface PropsType {
  param: ParamType
  setParam: React.Dispatch<React.SetStateAction<ParamType>>
}

const SelectCertificateTypeInCertificate:React.FC<PropsType> = ({param, setParam}) => {
  const [ items, setItems ] = useState<TypeOfCertificateType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  
  useEffect(() => {
    setInputItem(param?.type?.name || '')
  }, [param.type])
  
  useEffect(() => {
    setSelectedIndex(0)
    ApiService.certificates.getTypes()
      .then((response: any) => {
        if(response.data) setItems(response.data)
      })
      .catch((error: any) => {
        console.log(error)
      })
  }, [inputItem])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: TypeOfCertificateType) => {
    setInputItem(item.name)
    setShowOptions(false)
    setParam(prev => ({
      ...prev,
      type: item
    }))
  }
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  return(
    <InputDiv>
      <Label>Tipo de certificado</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder='Selecione'
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((ct, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(ct)}
              isSelected={index === selectedIndex}
            >
              {ct.name}
            </Option>
          )}
        </SearchOptions>
      }
    </InputDiv>
  )
}

export default SelectCertificateTypeInCertificate

